/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsEnumerationTypesEmailNotificationPreference } from './WebApiModelsEnumerationTypesEmailNotificationPreference';
import {
    WebApiModelsEnumerationTypesEmailNotificationPreferenceFromJSON,
    WebApiModelsEnumerationTypesEmailNotificationPreferenceFromJSONTyped,
    WebApiModelsEnumerationTypesEmailNotificationPreferenceToJSON,
} from './WebApiModelsEnumerationTypesEmailNotificationPreference';

/**
 * A family member as listed for their primary member on the public site.
 * @export
 * @interface WebApiPublicSiteDtoFamilyMemberOwnedDto
 */
export interface WebApiPublicSiteDtoFamilyMemberOwnedDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiPublicSiteDtoFamilyMemberOwnedDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WebApiPublicSiteDtoFamilyMemberOwnedDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiPublicSiteDtoFamilyMemberOwnedDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiPublicSiteDtoFamilyMemberOwnedDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiPublicSiteDtoFamilyMemberOwnedDto
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesEmailNotificationPreference}
     * @memberof WebApiPublicSiteDtoFamilyMemberOwnedDto
     */
    emailNotificationPreference?: WebApiModelsEnumerationTypesEmailNotificationPreference;
}

/**
 * Check if a given object implements the WebApiPublicSiteDtoFamilyMemberOwnedDto interface.
 */
export function instanceOfWebApiPublicSiteDtoFamilyMemberOwnedDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiPublicSiteDtoFamilyMemberOwnedDtoFromJSON(json: any): WebApiPublicSiteDtoFamilyMemberOwnedDto {
    return WebApiPublicSiteDtoFamilyMemberOwnedDtoFromJSONTyped(json, false);
}

export function WebApiPublicSiteDtoFamilyMemberOwnedDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiPublicSiteDtoFamilyMemberOwnedDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'phoneNumber': !exists(json, 'phoneNumber') ? undefined : json['phoneNumber'],
        'emailNotificationPreference': !exists(json, 'emailNotificationPreference') ? undefined : WebApiModelsEnumerationTypesEmailNotificationPreferenceFromJSON(json['emailNotificationPreference']),
    };
}

export function WebApiPublicSiteDtoFamilyMemberOwnedDtoToJSON(value?: WebApiPublicSiteDtoFamilyMemberOwnedDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'email': value.email,
        'phoneNumber': value.phoneNumber,
        'emailNotificationPreference': WebApiModelsEnumerationTypesEmailNotificationPreferenceToJSON(value.emailNotificationPreference),
    };
}

